// 品番マスタ画面で共有するパネル種別の定数。
// 本体と描画コンポーネントの双方から参照するため、モジュールへ切り出している。

// セクション編集ボタンを出す加工指示パネル(0件表示でもボタンを出すかどうかで2分割)。
export const KAKOUSIJI_NONZERO_EDIT_BUTTON_PANEL_TYPES = ['108', '113', '116', '120', '125', '133', '135'];
export const KAKOUSIJI_ZERO_EDIT_BUTTON_PANEL_TYPES = ['140', '141', '142', '143', '144', '145', '146', '147'];
export const KAKOUSIJI_EDIT_BUTTON_PANEL_TYPES = [...KAKOUSIJI_NONZERO_EDIT_BUTTON_PANEL_TYPES, ...KAKOUSIJI_ZERO_EDIT_BUTTON_PANEL_TYPES];

// 更新者/更新日時の表示対象となるパネル。
export const EDIT_UPDATE_TRACKING_PANEL_TYPES = ['101', '102', '103', '104', '105', '200', '210', '220', '230', ...KAKOUSIJI_EDIT_BUTTON_PANEL_TYPES];
